import { Component } from '@angular/core';
import { ItemTemplateDirective, MultiSelectComponent, TagTemplateDirective } from '@progress/kendo-angular-dropdowns';
import { ToggleArrowComponent } from '../../../../../../shared/components/ui/toggle-arrow/toggle-arrow.component';
import { distinctUntilChanged, map } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { hideRemovedOptionsWhenFieldEnabled } from '../../../functions/hide-removed-options';
import { formsActions } from '../../../../../../store/features/forms/forms-actions';
import { NgClass, NgStyle } from '@angular/common';
import { ComboboxControlComponent } from '../combobox-control/combobox-control.component';

@Component({
  selector: 'bizz-checklist-group-control',
  standalone: true,
  imports: [
    ItemTemplateDirective,
    MultiSelectComponent,
    TagTemplateDirective,
    ToggleArrowComponent,
    NgClass,
    NgStyle
  ],
  templateUrl: '../combobox-control/combobox-control.component.html',
  styleUrl: '../combobox-control/combobox-control.component.scss'
})
export class ChecklistGroupControlComponent extends ComboboxControlComponent {
  public override allowCustom = true;

  public override ngOnInit(): void {

    this.formField$.pipe(
      map((field) => {
        return field?.FieldValues;
      }),
      distinctUntilChanged((prev, curr) => {
        return JSON.stringify(prev) === JSON.stringify(curr);
      }),
      takeUntilDestroyed(this.destroyRef)
    )
      .subscribe(() => {
        const field = this.formFieldSignal();
        if (field) {
          // Setup data and filtered data arrays
          this.setupData(field);
          this.data = hideRemovedOptionsWhenFieldEnabled(this.data, field.Value);
          this.filteredData = this.data.slice();
        }

      });


    // Call parent ngOnInit
    super.ngOnInit();
  }

  /**
   * Handles the MultiSelect value change event and sets the formControl value. Disables multiple selection by slicing arrays longer than 1 to the last value.
   * @param value
   */
  public override onValueChange(value: any): void {
    const fieldId = this.formFieldSignal()?.Id;
    if (this.formFieldSignal()?.aiGeneration?.aiValue !== undefined && this.formFieldSignal()?.aiGeneration?.aiValue.value !== value) {
      this.store$.dispatch(formsActions.updateFormFieldAiGeneration({
        formId: this.formId,
        gridFieldId: undefined,
        recordId: undefined,
        fieldId: fieldId ?? 0,
        value: { aiValue: undefined, generated: false, confirmed: false }
      }));
    }
    // Disables multiple selection
    if (Array.isArray(value) && value.length > 1) {
      value = value.slice(-1);
    }
    if (value.length > 0 && value[0].CollectionFieldValuesID == undefined) {
      this.store$.dispatch(formsActions.createChecklistGroupValue({
        formId: this.formId,
        caption: value[0],
        gridFieldId: this.gridFieldId,
        recordId: this.recordId,
        collectionFieldsId: this.formFieldSignal()?.CollectionFieldsID ?? 0
      }));
    }
    this.formControl.setValue(value);
  }
}